<template>
<div id="login">
  <div class="login-head">
    <div v-if="errorMessage" class="login-message" v-html="errorMessage"></div>
  </div>
  <div class="login-window">
    <form v-on:submit.prevent="login">
      <fieldset>
        <legend><strong>Login geOps ServiceDesk</strong></legend>
        <p>Username</p>
        <input type="text" id="username" name="username" ref="username" value=""><br>
        <p>Passwort</p>
        <input type="password" id="password" name="password" ref="password" value=""><br><br>
        <input type="submit" value="login"><br>
      </fieldset>
    </form>
  </div>
</div>
</template>

<script>

export default {
  name: 'login',

  data() {
    return {
      errorMessage: null,
      confSpaces: null,
      method: null,
    };
  },

  created() {
    if (this.$route.query.perm === 'false') {
      this.errorMsg('> Zugriffsrechte Problem');
    }
    if (this.$route.params.key) {
      this.routeKey = this.$route.params.key.toLowerCase();
    } else if (this.$route.params.method) {
      this.method = this.$route.params.method;
      this.targetKey = this.$route.params.targetKey;
    }
  },

  methods: {
    errorMsg(message) {
      this.errorMessage = message;
    },

    storeLocalUsers(users, userName, portalKey) {
      const storedMessages = {
      };
      storedMessages[portalKey] = '';
      users[userName] = {
        name: userName,
        lastNews: storedMessages,
      };
      localStorage.setItem('users', JSON.stringify(users));
      return JSON.parse(localStorage.getItem('users'));
    },

    getLocalStorage(userName, portalKey) {
      let users;
      if (!localStorage.getItem('users')) {
        users = this.storeLocalUsers({}, userName, portalKey);
      } else {
        users = JSON.parse(localStorage.getItem('users'));
        if (!Object.prototype.hasOwnProperty.call(users, userName)) {
          this.storeLocalUsers(users, userName);
        }
      }
    },

    login() {
      const formData = new FormData();
      formData.append('username', this.$refs.username.value);
      formData.append('password', this.$refs.password.value);
      if (this.routeKey) {
        formData.append('portal', this.routeKey);
      }
      if (this.targetKey) {
        if (this.method === '2') {
          formData.append('page_key', this.targetKey);
        } else {
          formData.append('issue_key', this.targetKey);
        }
      }

      const self = this;
      const portalKey = this.routeKey;
      axios({
        method: 'post',
        url: '/app/login',
        data: formData,
        headers: {
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then((response) => {
        // LocalStorage to handle user message display on login.
        if (portalKey) {
          this.getLocalStorage(response.data.username, portalKey);
        }

        this.$store.commit('setUserName', response.data.username);
        this.$store.commit('setIsLogin', true);

        if (this.method === '1') {
          this.$router.push(`/issue/${this.targetKey}`);
        } else if (this.method === '2') {
          this.$router.push(`/page/${this.targetKey}`);
        } else if (this.routeKey) {
          this.$router.push(`/${this.routeKey}`);
        }
      }).catch((error) => {
        if (error.response.data.message) {
          self.errorMsg(error.response.data.message);
        } else {
          self.errorMsg('> Login fehlgeschlagen');
        }
      });
    },
  },
};
</script>

<style scoped>
#login {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 50px;
  padding: 10px;
}

fieldset {
border: dashed 1px #ccc;
}
.login-head {
  padding-bottom: 25px;
  text-align: left;
}
.title-login{
  float:left;
}
.title-login span {
  font-size: 25px;
}
.log-div {
  margin-right: 20px;
  float:left;
}
.floatClear {
    clear: both;
}
.login-window {
  max-width: 450px;
  margin: auto;
}
.login-window p {
  text-align: left;
}

.login-message {
  max-width: 450px;
  margin: auto;
  color: #BD3724;
}

.login-message a {
  color: #BD3724;
}

input:not([type="submit"]) {
  width: 100%;
  margin-bottom: 2px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1) inset;
  box-sizing: border-box;
  padding: 8px;
}

input[type=submit] {
  padding:5px 25px;
  background:#6496c8;
  border:0 none;
  cursor:pointer;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin-top: 15px;
  margin-bottom: 15px;
}

input[type=submit]:hover {
  background: #346392;
}

</style>


// WEBPACK FOOTER //
// Login.vue?0d539676